import { Typography } from '@breetometer/components';
import { AnimatedLoaderIcon } from 'BreetAssets';

const LoadingDialog = () => (
	<div className='loading_dialog'>
		<AnimatedLoaderIcon />
		<Typography
			as='p'
			id='loading-dialog-message'
		/>
	</div>
);

export default LoadingDialog;
